export const communicationsDrawerTaktId = 'aces-communications-drawer-wrapper';
